export default ["Creek", "Multi days", "Playspot", "River run"];
